// extracted by mini-css-extract-plugin
module.exports = {"container":"CriticalErrorBoundary_container__1lsDl","header":"CriticalErrorBoundary_header__3Nde4","text":"CriticalErrorBoundary_text__3FWpz"};